<template>
    <v-card class="mx-auto" max-width="700">
        <v-toolbar color="blue" dark>
            <v-toolbar-title><v-icon>sort</v-icon> Ordenar Pagos</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="fuSave" :loading="dLoading"><v-icon left>save</v-icon> Guardar Cambios</v-btn>
        </v-toolbar>
        <v-card-text v-if="dLoading" class="pa-4">
            <v-skeleton-loader
                type="list-item-avatar-two-line@4"
                class="my-2"
            ></v-skeleton-loader>
        </v-card-text>
        <v-list v-else two-line class="py-0">
            <v-list-item-group active-class="blue--text" multiple>
                <draggable v-model="dVsColeProyCuota" tag="div" @start="drag = true" @end="drag = false">
                    <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                        <v-list-item v-for="(item, index) in dVsColeProyCuota"  :key="item.nrocuota">
                            <v-list-item-icon><v-icon color="indigo">drag_indicator</v-icon></v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>
                                    <span class="font-weight-bold mr-2">S/. {{ item.saldo }}</span>
                                </v-list-item-title>
                                <v-list-item-subtitle class="text--primary" v-text="item.glosa"></v-list-item-subtitle>
                                <v-list-item-subtitle>
                                    <v-chip :color="fuColor12Fecha(item.fven)" outlined>{{ fuMesNombreFecha(item.fven) }}</v-chip>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-list-item-action-text v-text="item.fven.substring(0,10)"></v-list-item-action-text>
                                <v-icon @click="fuCopy(item.codcli)" :title="item.codcli" color="grey lighten-1">access_time_filled</v-icon>
                            </v-list-item-action>                            
                        </v-list-item>
                    </transition-group>
                </draggable>
            </v-list-item-group>
        </v-list>
        <v-divider></v-divider>
        <v-card-text class="pt-5 d-flex justify-center">
            <v-btn @click="fuLoad(pCodigo)" outlined color="teal accent-4"><v-icon>sync</v-icon> Actualizar</v-btn>
        </v-card-text>
    </v-card>
</template>
<script>
import moment from 'moment';
import gql from 'graphql-tag';
import draggable from 'vuedraggable';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import {fuColor12Fecha, fuMesNombreFecha, fuCopy} from '@/helpers/index.js';

export default {
    name: 'CResumenPago',
    components: {draggable,},
    props: ['pCodigo'],
    mounted(){
    	this.fuLoad(this.pCodigo);
    },
    data: () => ({
        drag: false,
        dLoading: false,
        dVsColeProyCuota: [],
    }),
    watch: {
        pCodigo(val){
            if(val)
                this.fuLoad(val);
        },
    },
    methods: {
        fuColor12Fecha, fuMesNombreFecha, fuCopy,
        async fuLoad(vCodigo){
            this.dLoading = true;
            this.dVsColeProyCuota = [];
            try {
                const response = await this.$apollo.query({
                    query: gql`query load($cdbarra: String!){
                        vscoleproycuota(cdbarra:$cdbarra){
                            codcli
                            glosa
                            fven
                            idproycuota
                            saldo
                            nrocuota
                        }
                    }`,
                    variables: {
                        cdbarra: vCodigo,
                    },
                    fetchPolicy: 'no-cache'
                })
                this.dVsColeProyCuota = response.data.vscoleproycuota;
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Problema de Conexión.', 'error');
            } finally {
                this.dLoading = false;
            }            
        },
        async fuSave(){
            const CIDSPROYCUOTAS = this.dVsColeProyCuota.map(item => item.idproycuota).join(',');

            try {
                this.dLoading = true;

                const response = await this.$apollo.mutate({
                    mutation: gql`mutation vscoleproycuota_ordenar($idproycuotas: String!){
                        vscoleproycuota_ordenar(idproycuotas: $idproycuotas){
                            error
                        }
                    }`,
                    variables: {
                        idproycuotas: CIDSPROYCUOTAS,
                    }
                });
                if(response.data){
                    Swal.fire('Correcto', 'Registro correcto', 'success');
                } else {
                    Swal.fire('¡ ERROR !', 'Registro incorrecto', 'error');
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Registro incorrecto.', 'error');
            } finally {
                this.dLoading = false;
            }
        },
    }
}
</script>
<style scoped>
/* Estilo para la transición de elementos al reordenar */
.flip-list-move {
    transition: transform 0.5s;
}

/* Estilo para el elemento que se está arrastrando */
.ghost {
    opacity: 0.5;
    background: #c8ebfb;
}
</style>
